export const Errors = {
    "email": "Please enter your e-mail address",
    "password": "Please enter your password",
    "required": "This field is required"
}